export const environment = {
  API: 'https://apidev-cobranza.fianly.com/',
  production: true,
  WompyURL: 'https://sandbox.wompi.co/v1/',
  FianlyLanding: 'https://fianly.com/',
  checkout: {
    confirmation: "https://api-cobranza.fianly.com/gateway/v1/gateway",
    response: "https://cobranza.fianly.com/pago/epayco-respuesta",
    wompiResponse: "https://cobranza.fianly.com/pago/respuesta"
  },
  epaycoKeys: {
    card: 'b17a9f4089a2084bf0cb3347d55a216c',
    cash: '3f89ac674fb4d9794dce2ecabb139256'
  },
  wompyKeys: {
    card: 'pub_test_AP1jXaUG9OUoJHoPydYkthLpxTj6AV10',
    cash: 'pub_test_8ubuzNXTlt1t979ErFiBIZAwVInPjngM',
  },
  superMayorLink: 'https://www.superfinanciera.gov.co/publicaciones/10829/sala-de-prensacomunicados-de-prensa-interes-bancario-corriente-10829/'
};
